export default [
  {
    path: "*",
    component: () => import("../components/NotFound.vue"),
    meta: {
      title: "ERRORS:NOT_FOUND:TITLE-TEXT",
    },
  },
];
